export default {
  lectureList: [],
  scriptList: [],
  lectureScriptList: [],
  examList: [],
  lectureExamList: [],
  lectureDetails: {},
  chapterDetail: {},
  uploadPercentage: 0
}
